import { Identifier } from "react-admin";

import { ColumnsOf } from "../data";

import { Maybe } from "../utility";

export const locationSource = {
  // Location source on device to tell what it was used to locate the device
  GpsTracker: "gps.tracker",
  GpsGateway: "gps.gateway",

  // Location source on space to tell location method it should use
  GPS: "gps",
  Anchor: "anchor",
  Gateway: "gateway",
  Auto: "auto"
} as const;

export type LocationSource = (typeof locationSource)[keyof typeof locationSource];

export interface Space {
  id: string;
  name: string;
  type: Maybe<string>;
  tags: Maybe<string[]>;
  meta: Maybe<unknown>;
  created_at: string;
  created_by: Maybe<string>;
  updated_at: string;
  updated_by: Maybe<string>;
  agent: string;
  parent_id: Maybe<Identifier>;
  spaces?: Maybe<Space[]>;
  is_default?: Maybe<boolean>;
  config: Maybe<unknown>;
  located_by?: Maybe<LocationSource>;
  anchor_gwid_notif_period?: Maybe<number>;
  anchor_gwid_half_life?: Maybe<number>;
  anchor_gwid_rssi_missing?: Maybe<number>;
  anchor_gwid_rssi_effective?: Maybe<number>;
}

export interface SpaceInfo {
  id: string;
  name: string;
  parent_id: Maybe<Identifier>;
  tags: Maybe<string[]>;
  located_by?: Maybe<LocationSource>;
  assets: number;
  anchors: number;
  trackers: number;
  users: number;
  apps: number;
  sites: number;
}

export const SPACE_INFO_COLUMNS: ColumnsOf<SpaceInfo> = ["*"] as const;

export type SpaceInsert = Pick<
  Space,
  | "name"
  | "tags"
  | "parent_id"
  | "located_by"
  | "anchor_gwid_notif_period"
  | "anchor_gwid_half_life"
  | "anchor_gwid_rssi_missing"
  | "anchor_gwid_rssi_effective"
>;
export type SpaceUpdate = Partial<
  Pick<
    Space,
    | "name"
    | "tags"
    | "located_by"
    | "anchor_gwid_notif_period"
    | "anchor_gwid_half_life"
    | "anchor_gwid_rssi_missing"
    | "anchor_gwid_rssi_effective"
  >
>;

export const SPACE_COLUMNS: ColumnsOf<Space> = ["*"] as const;
